module.exports = __webpack_public_path__ + "img/py.pyb4f1de6.svg";